import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../redux/root-reducer';
import { endpoints } from '../../utils/endpoints';
import { fetchJSON } from '../../utils/fetch';
import { tokenSelector } from '../authentication/authentication-selectors';
import { Answer } from './custom-form-factory-types';
import { FormUpdate } from './registration-form-types';

const get = endpoints();

export const formUpdate = createAction<FormUpdate>('registrationForm/update');

export const submitFormAnswersWithInviteId = (
  eventSlug: string,
  inviteId: number,
  answers: Answer[],
  token: Nullable<string>,
) => {
  const headers: HeadersInit = {
    Accept: 'application/json',
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return fetchJSON(get('FORM_ANSWERS')(eventSlug, inviteId), {
    method: 'POST',
    headers,
    body: {
      answers,
    },
  });
};

export const submitFormAnswersAuthenticated = (
  eventSlug: string,
  answers: Answer[],
  token: string,
) => {
  return fetchJSON(get('FORM_ANSWERS_DIRECT')(eventSlug), {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: {
      answers,
    },
  });
};
